import { onDOMReady } from './dom';

onDOMReady(function () {
    const deliveryDateTimeConfirmationForm = document.getElementById('kvikymart-shopping-cart-delivery-date-time-confirmation-form');

    if (!deliveryDateTimeConfirmationForm) {
        return;
    }

    const recapitulationForm = document.getElementById('kvikymart-shopping-cart-recapitulation-form');
    const orderCartOverviewDeliveryDateTimes = document.getElementsByClassName('orderCartOverview__deliveryDateTime');

    if (!recapitulationForm || !orderCartOverviewDeliveryDateTimes.length) {
        return;
    }

    const orderCartOverviewDeliveryDateTime = orderCartOverviewDeliveryDateTimes[0];
    const orderCartOverviewDeliveryDateTimeText = orderCartOverviewDeliveryDateTime.querySelector('strong');
    const hiddenRadio = recapitulationForm.querySelector('input[name="deliveryDateTimeConfirmation"]');
    const radioButtons = deliveryDateTimeConfirmationForm.querySelectorAll('input[type="radio"][name="deliveryDateTimeConfirmation[deliveryDateTimeConfirmation]"]');
    recapitulationForm.querySelector('input[name="deliveryDateTimeConfirmationMode"]').value = deliveryDateTimeConfirmationForm.querySelector('input[name="deliveryDateTimeConfirmationMode"]').value;
    recapitulationForm.querySelector('input[name="deliveryDateTimeConfirmationEarliestDate"]').value = deliveryDateTimeConfirmationForm.querySelector('input[name="deliveryDateTimeConfirmationEarliestDate"]').value;
    radioButtons.forEach(function (radio) {
        radio.addEventListener('change', function () {
            hiddenRadio.value = radio.value;

            const table = radio.closest('table.deliveryDateTimeConfirmation');
            if (!table) {
                return;
            }

            const confirmedLabel = radio.dataset.deliveryDateLabelConfirmed;
            const declinedLabel = radio.dataset.deliveryDateLabelDeclined;

            orderCartOverviewDeliveryDateTimeText.textContent =
                radio.value === 'confirmed' ? confirmedLabel : declinedLabel;
        });
    });

    const submitButton = recapitulationForm.querySelector('input[type="submit"]:not([id="frm-cartOrderSubmit-submited"])');
    const originalOnClick = submitButton.getAttribute('onclick');
    submitButton.removeAttribute('onclick');

    const handleSubmit = function (event) {
        event.preventDefault();
        if (window.Nette && window.Nette.validateForm(deliveryDateTimeConfirmationForm)) {
            // Restore original onclick and trigger the original click behavior
            submitButton.setAttribute('onclick', originalOnClick);
            submitButton.removeEventListener('click', handleSubmit);
            submitButton.click();
        }
    };

    submitButton.addEventListener('click', handleSubmit);
});
